var slidesToShow = $('.testimonials-slider').data('slides-to-show') || 2;

$('.testimonials-slider').slick({
  infinite: true,
  slidesToShow: slidesToShow,
  slidesToScroll: 1,
  dots: false,
  prevArrow: `
  <button type="button" class="slick-prev slick-arrow">
    <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 10 6">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="#3f464b">
    </svg>
  </button>`,
  nextArrow: `
  <button type="button" class="slick-next slick-arrow">
    <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 10 6">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="#3f464b">
    </svg>
  </button>`,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
      },
    },
  ],
});
